import { mdLabel, frequencyValue, habitGoal } from '@/utils/Habits'

export default {
    methods: {
        habitName(habit) {
            if (!habit) return ''
            if (habit.baseId) return this.$t(`habits.catalog.${habit.baseId}`)
            return habit.name || this.$t('habits.custom_habit')
        },
        habitCategoryLabel(category) {
            return this.$t(`habits.categories.${category || 'custom'}`)
        },
        habitTypeLabel(type) {
            return this.$t(`habits.types.${type}`)
        },
        habitUnitLabel(unit) {
            if (!unit) return ''
            return this.$te(`habits.units.${unit}`) ? this.$t(`habits.units.${unit}`) : unit
        },
        habitFrequencyLabel(frequency, long = false) {
            const value = frequencyValue(frequency)
            if (value === 'daily') return this.$t('habits.freq.daily')
            if (frequency.kind === 'weekly') return this.$t('habits.freq.weekly', { n: frequency.times })
            if (long) return `${mdLabel(frequency.offset)} · ${this.$t(`habits.freq.md_${frequency.offset}`)}`
            return mdLabel(frequency.offset)
        },
        habitFrequencySummary(habits = []) {
            let daily = 0
            let weekly = 0
            const md = { '-1': 0, '0': 0, '1': 0 }
            habits.forEach(habit => {
                const kind = habit.frequency?.kind || 'daily'
                if (kind === 'daily') daily++
                else if (kind === 'weekly') weekly++
                else md[habit.frequency.offset]++
            })
            const out = []
            if (daily) out.push(this.$tc('habits.summary.daily', daily, { n: daily }))
            if (weekly) out.push(this.$tc('habits.summary.weekly', weekly, { n: weekly }))
            ;[-1, 0, 1].forEach(offset => { if (md[offset]) out.push(`${md[offset]} ${mdLabel(offset)}`) })
            return out.join(' · ')
        },
        habitGoalLabel(habit, goals) {
            if (habit.type === 'bool') return this.$t('habits.yes_no')
            const goal = habitGoal(habit, goals)
            return `${this.formatHabitNumber(goal)} ${this.habitUnitLabel(habit.unit)}`.trim()
        },
        formatHabitNumber(value) {
            if (value === null || value === undefined || value === '') return '-'
            return Number(value).toLocaleString(this.$i18n.locale, { maximumFractionDigits: 2 })
        },
        formatHour(hour) {
            return `${String(hour).padStart(2, '0')}:00`
        },
    },
}
